<template>
  <div id="viewFile"></div>
</template>

<script>
import axios from "axios";

const getViewUrlWebPath = (params) => {
  return axios.get(
    "https://www.ljserver.cn/wps/v1/api/file/getViewUrlWebPath",
    { params: params }
  );
};

export default {
  name: "AppLookPPT", // 查看课件
  data() {
    return {
      jwpsUrl: "", // wps url
      jtoken: "", // wps token
      // 是否开启简易模式
      simpleMode: false
    };
  },
  created() {
    this.getViewUrlWebPath();
  },
  methods: {
    // 获取web地址
    async getViewUrlWebPath() {
      const params = {
        fileUrl: this.$route.query.url
      };
      const { data } = await getViewUrlWebPath(params);
      if (data.code === 200) {
        console.log(data.data, "data");
        // this.jwpsUrl = data.data.wpsUrl;
        // this.jtoken = data.data.token;
        this.openWps(data.data.wpsUrl, data.data.token);
        // } else {
        //   this.$message.error(data);
      }
    },
    openWps(url, token) {
      console.info(url);
      this.wps = this.$wps.config({
        mode: this.simpleMode ? "simple" : "normal",
        mount: document.querySelector("#viewFile"),
        wpsUrl: url,
        commonOptions: {
          // isShowTopArea: false, // 隐藏顶部区域（头部和工具栏）
          isShowHeader: false, // 隐藏头部区域
          isBrowserViewFullscreen: false, // 是否在浏览器区域全屏
          isIframeViewFullscreen: false // 是否在 iframe 区域内全屏
        }
      });
      this.wps.setToken({ token });
      this.example();
      this.wps.on("error", (err) => {
        console.log("发生错误：", err);
      });
    },
    // 隐藏打印
    async example() {
      await this.wps.ready();
      const app = this.wps.WppApplication();
      // 页面定制对象：更多菜单
      const moreMenus = await app.CommandBars("TabPrintPreview");
      // // 控制更多菜单隐藏
      moreMenus.Visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
html {
  height: 97.5%;
  width: 99%;
}

body {
  height: 100%;
  width: 100%;
}

body #app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}

body #app #wps-iframe {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  height: 100%;
  /* 防止双击缩放 */
  touch-action: manipulation;
}

#office-iframe {
  height: 100vh !important;
}

.web-office-iframe {
  height: 100vh !important;
}

#viewFile {
  width: 100vw !important;
  height: 100vh !important;
}
</style>
